import axios from 'axios'
import { lockAccess } from '@/common/access'

export default class Request {
  constructor() {
    this.cancelHash = {}
    this.publicationId = window.location.pathname.match(/\/publications\/([a-zA-Z0-9-]+)/)[1]
    this.headers = {
      'Content-Type': 'application/json',
    }
  }

  newError(originalError) {
    throw originalError
  }

  request(method, url, data, options) {
    if (options?.cancel) this.cancelHash[options.cancel]?.()

    return axios({
      url: '/' + url,
      method,
      headers: this.headers,
      data,
      withCredentials:
        options?.withCredentials != null
          ? options?.withCredentials
          : this.withCredentials,
      params: options?.params,
      // Настройки axios-retry для одного запроса (плагин читает их из этого ключа)
      'axios-retry': options?.retry,
      cancelToken: new axios.CancelToken((c) => {
        if (options?.cancel) this.cancelHash[options.cancel] = c
      }),
    })
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          return Promise.reject(error)
        }

        // Любой запрос, а не только bootstrap: cookie доступа может истечь или пароль сменят посреди просмотра
        lockAccess(error?.response)

        if (error?.response) {
          console.log(`${this.server}/${url}`)
          console.log(error.response?.status)
          console.log(error.response?.method)
          console.log(error.response?.path)
          console.log(error.response?.data)
        }

        // Sentry.captureException(error)

        return Promise.reject(
          error.response
            ? this.newError(error, error.response.status, error.response.data)
            : error
        )
      })
  }
}
